/** Wider than the observed ~100-140 byte overhead so real frames always
 * land inside the band, but still narrow enough that i8 (1 byte/elem) and
 * f16 (2 bytes/elem) never collide for any nEmbd this repo ships
 * (>=4096 -> their expected byte counts are thousands of bytes apart). */
const OVERHEAD_TOLERANCE_BYTES = 160;
const CANDIDATES = [
    { dtype: 'i8', bytesPerElement: 1 },
    { dtype: 'f16', bytesPerElement: 2 },
    { dtype: 'f32', bytesPerElement: 4 },
];
export function wireDtypeFromFrameBytes(bytes, nEmbd) {
    if (!(bytes > 0) || !(nEmbd > 0))
        return '?';
    let best;
    for (const candidate of CANDIDATES) {
        const expected = nEmbd * candidate.bytesPerElement;
        const diff = Math.abs(bytes - expected);
        if (diff <= OVERHEAD_TOLERANCE_BYTES && (!best || diff < best.diff)) {
            best = { dtype: candidate.dtype, diff };
        }
    }
    return best?.dtype ?? '?';
}
